import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'
import { injectIntl } from 'react-intl'
import {
  hideHomeInsuranceDetail,
  trackCoveredButtonClick
} from 'src/actions/homeInsurance'
import { saveHomeInsuranceOptOut } from 'src/actions/client'
import { selectAnswerInsuranceFeedback } from 'src/store/selectors/client'
import { HOME_INSURANCE } from 'src/constants/messages'
import { COVERED_URI } from 'src/constants/homeInsurance'
import { flashNotification } from 'src/actions/notification'
import { getFullLocation } from 'src/helpers/browser'

const HomeInsuranceDetailContainer = compose(
  injectIntl,
  connect(
    state => ({
      hasFeedback: selectAnswerInsuranceFeedback(state),
      coveredUri: `${COVERED_URI}?returnUrl=${encodeURIComponent(
        getFullLocation()
      )}`
    }),
    dispatch => ({
      hideDetail: () => dispatch(hideHomeInsuranceDetail()),
      positiveFeedback: () => dispatch(saveHomeInsuranceOptOut(false)),
      negativeFeedback: () => dispatch(saveHomeInsuranceOptOut(true)),
      notify: message => dispatch(flashNotification(message)),
      trackCoveredButtonClick: () => dispatch(trackCoveredButtonClick())
    })
  ),
  withState('submittedFeedback', 'setSubmittedFeedback', false),
  withHandlers({
    handlePositiveFeedback: ({
      intl,
      notify,
      positiveFeedback,
      setSubmittedFeedback
    }) => event => {
      setSubmittedFeedback(() => true)
      positiveFeedback()
      notify(intl.formatMessage(HOME_INSURANCE.feedbackReceived))
    },
    handleNegativeFeedback: ({
      intl,
      notify,
      negativeFeedback,
      setSubmittedFeedback
    }) => event => {
      setSubmittedFeedback(() => true)
      negativeFeedback()
      notify(intl.formatMessage(HOME_INSURANCE.feedbackReceived))
    }
  })
)

export default HomeInsuranceDetailContainer
